import { useRolodexEntriesCachedById } from 'features/knowledgeDocumentViewer/hooks/useRolodexEntriesCachedById'
import { toTitleCase } from 'features/knowledgeDocumentViewer/utils/textHelpers'
import styled from 'styled-components'
import { SystemDocumentEntry } from 'types'

const DocumentTitle = styled.p`
  font-size: 0.875rem;
  line-height: 1.2;
  color: ${(props) => props.theme.forecast.defaultText};
`

const DocumentSubtitle = styled.p`
  font-size: 0.6875rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  line-height: 1.2;
`

export type DocumentInfo = {
  title: string
  filename: string
  system: string
  vendor: string
  docType: string
  drawing: string
  revisionCode: string
  revisionDate: string
}

type DocumentHeaderTitleProps = {
  documentId: string
  customTitle?: string
}

export function DocumentHeaderTitle({
  documentId,
  customTitle,
}: DocumentHeaderTitleProps) {
  const { data: systemDocumentEntries } =
    useRolodexEntriesCachedById<SystemDocumentEntry>(
      documentId ? [documentId] : []
    )
  const entry = systemDocumentEntries?.[0]?.entry

  const documentInfo: DocumentInfo = {
    title: entry?.data.document_title ?? '',
    filename: entry?.data.filename ?? '',
    system: entry?.data.system ?? '',
    vendor: entry?.data.vendor_name ?? '',
    docType: entry?.data.document_type ?? '',
    drawing: entry?.data.drawing_number ?? '',
    revisionCode: entry?.data.revision_code ?? '',
    revisionDate: entry?.data.revision_date ?? '',
  }

  const getSubtitle = (documentInfo: DocumentInfo): string => {
    const subtitleParts = []
    if (documentInfo.revisionCode && documentInfo.revisionDate) {
      subtitleParts.push(
        `Revision ${documentInfo.revisionCode} (${documentInfo.revisionDate})`
      )
    } else if (documentInfo.revisionCode) {
      subtitleParts.push(`Revision ${documentInfo.revisionCode}`)
    } else if (documentInfo.revisionDate) {
      subtitleParts.push(`${documentInfo.revisionDate}`)
    }
    if (documentInfo.system) {
      subtitleParts.push(`${documentInfo.system}`)
    }
    if (documentInfo.vendor) {
      subtitleParts.push(`${documentInfo.vendor}`)
    }
    if (documentInfo.docType) {
      subtitleParts.push(`${documentInfo.docType}`)
    }
    if (documentInfo.drawing) {
      subtitleParts.push(`${documentInfo.drawing}`)
    }
    return subtitleParts.join(' •  ')
  }

  const showCustomTitle = customTitle && !documentId

  const displayTitle = showCustomTitle
    ? customTitle
    : documentInfo.title
      ? toTitleCase(documentInfo.title)
      : ''

  return (
    <div>
      <DocumentTitle>{displayTitle}</DocumentTitle>
      {!showCustomTitle && (
        <DocumentSubtitle>{getSubtitle(documentInfo)}</DocumentSubtitle>
      )}
    </div>
  )
}
